import React, { useState, useEffect } from 'react';
import { Upload, X } from 'lucide-react';
import api from '../utils/api';

const LogoManagement = () => {
  const [logo, setLogo] = useState(null);
  const [logoPreview, setLogoPreview] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    fetchCurrentLogo();
  }, []);

  const fetchCurrentLogo = async () => {
    try {
      const response = await api.getCurrentLogo();
      if (response && response.logo_url) {
        setLogoPreview(response.logo_url);
      }
    } catch (error) {
      console.error('Error fetching logo:', error);
    }
  };

  const handleLogoUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      setLogo(file);
      const reader = new FileReader();
      reader.onload = (e) => setLogoPreview(e.target.result);
      reader.readAsDataURL(file);
    }
  };

  const removeLogo = () => {
    setLogo(null);
    setLogoPreview(null);
  };

  const uploadLogo = async () => {
    if (logo) {
      try {
        setIsLoading(true);
        await api.uploadLogo(logo);
        alert('Logo saved successfully!');
        await fetchCurrentLogo(); // Refresh the logo after saving
      } catch (error) {
        console.error('Error saving logo:', error);
        alert('Failed to save logo. Please try again.');
      } finally {
        setIsLoading(false);
      }
    }
  };

  return (
    <div className="container">
      <h1>Logo Management</h1>
      
      <div className="card">
        <h3>Upload Chatbot Logo</h3>
        
        <div className="form-group">
          <label className="form-label">Current Logo</label>
          {logoPreview ? (
            <div style={{ position: 'relative', display: 'inline-block' }}>
              <img 
                src={logoPreview} 
                alt="Logo preview" 
                style={{ maxWidth: '200px', maxHeight: '200px', border: '1px solid #ddd', borderRadius: '4px' }}
              />
              <button 
                onClick={removeLogo}
                style={{ 
                  position: 'absolute', 
                  top: '5px', 
                  right: '5px', 
                  background: 'red', 
                  color: 'white', 
                  border: 'none', 
                  borderRadius: '50%', 
                  width: '25px', 
                  height: '25px',
                  cursor: 'pointer'
                }}
              >
                <X size={16} />
              </button>
            </div>
          ) : (
            <div 
              style={{ 
                border: '2px dashed #ddd', 
                padding: '40px', 
                textAlign: 'center', 
                borderRadius: '4px',
                cursor: 'pointer'
              }}
              onClick={() => document.getElementById('logo-input').click()}
            >
              <Upload size={48} color="#999" />
              <p>Click to upload logo</p>
              <p style={{ fontSize: '12px', color: '#666' }}>Supported formats: PNG, JPG, SVG</p>
            </div>
          )}
        </div>

        <input
          id="logo-input"
          type="file"
          accept="image/*"
          onChange={handleLogoUpload}
          style={{ display: 'none' }}
        />

        <div style={{ marginTop: '20px' }}>
          <button 
            className="btn btn-primary" 
            onClick={uploadLogo} 
            disabled={!logo || isLoading}
          >
            {isLoading ? 'Saving...' : 'Upload Logo'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default LogoManagement;